import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useRouter } from 'next/navigation'
import { SlArrowDown } from 'react-icons/sl'
import BlogCard from '@/app/blogs/component/BlogCard'
import BlogOne from '../../../../assets/blogs/blog-1.png'
import Link from 'next/link'

const RelatedContent = ({ relatedContent }) => {
	const router = useRouter()
	return (
		<>
			{relatedContent?.length > 0 && (
				<div className='blog-related-content-container'>
					<Row className=' m-0'>
						<h2>Related Content</h2>
					</Row>
					<Row className='blog-card-wapper m-0'>
						{relatedContent.map((item, i) => (
							<Col xs={12} md={3} lg={4} key={i}>
								<BlogCard data={item} AltImage={BlogOne} key={i} />
							</Col>
						))}
					</Row>
					<div className='d-flex justify-content-center'>
						<Link href={'/blogs'}>
							<button className='btn-view-more view-more border shadow-sm'>
								View More <SlArrowDown size='18' />
							</button>
						</Link>
					</div>
				</div>
			)}
		</>
	)
}

export default RelatedContent
